module.exports = __webpack_public_path__ + "img/knowledgeGraph.ca62429d.png";